/**
 * Nearest scrolling ancestor, or null for the viewport.
 *
 * `position: sticky` pins against whichever box actually scrolls, and anything that measures or
 * offsets a sticky element has to use that same box: an IntersectionObserver's root (the detail
 * toolbar's "stuck" divider), and the room left for the app shell's pinned top bar
 * (`--dd-sticky-header-offset`), which only the viewport scroller shares — a page that scrolls
 * inside its own container (the form-builder preview under the admin page's mat-drawer-content,
 * Storybook's docs surface) already starts below that bar.
 *
 * Only `auto` and `scroll` count: `hidden` and `clip` clip without scrolling, and the module
 * wrapper's `overflow-x: clip` must not end the pinning. The walk stops at `<body>`.
 */
export function nearestScrollport(element: HTMLElement): HTMLElement | null {
  for (let el = element.parentElement; el && el !== document.body; el = el.parentElement) {
    const overflowY = getComputedStyle(el).overflowY;
    if (overflowY === 'auto' || overflowY === 'scroll') return el;
  }
  return null;
}
